module.exports = __webpack_public_path__ + "static/img/2021-01.a90132d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/publication/2021-01.png
// module id = Lqil
// module chunks = 6